import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import "../../../geometry.js";
import e from "../../../Graphic.js";
import "../../../symbols.js";
import { makeHandle as r } from "../../../core/handleUtils.js";
import { px2pt as i } from "../../../core/screenUtils.js";
import { f as t, j as n } from "../../../chunks/vec2.js";
import { a as o } from "../../../chunks/vec2f64.js";
import { c as a } from "../../../chunks/vec3f64.js";
import { colors as l } from "../../draw/support/settings.js";
import { defaults as s } from "../../interactive/snapping/Settings.js";
import { SnappingVisualizer as p } from "../../interactive/snapping/SnappingVisualizer.js";
import m from "../../../symbols/SimpleMarkerSymbol.js";
import c from "../../../symbols/SimpleLineSymbol.js";
import y from "../../../symbols/CIMSymbol.js";
import b from "../../../geometry/Point.js";
import S from "../../../geometry/Polyline.js";

var h = /*#__PURE__*/function (_p) {
  _inherits(h, _p);

  var _super = _createSuper(h);

  function h(e) {
    var _this;

    _classCallCheck(this, h);

    _this = _super.call(this), _this.graphicsLayer = e;
    return _this;
  }

  _createClass(h, [{
    key: "visualizeIntersectionPoint",
    value: function visualizeIntersectionPoint(e, r) {
      return this._visualizeSnappingIndicator(new b({
        x: e.intersectionPoint[0],
        y: e.intersectionPoint[1],
        spatialReference: r.coordinateHelper.spatialReference
      }), u);
    }
  }, {
    key: "visualizePoint",
    value: function visualizePoint(e, r) {
      return this._visualizeSnappingIndicator(new b({
        x: e.point[0],
        y: e.point[1],
        spatialReference: r.coordinateHelper.spatialReference
      }), M);
    }
  }, {
    key: "visualizeLine",
    value: function visualizeLine(e, r) {
      return this._visualizeSnappingIndicator(new S({
        paths: [[e.lineStart, e.lineEnd]],
        spatialReference: r.coordinateHelper.spatialReference
      }), f);
    }
  }, {
    key: "visualizeParallelSign",
    value: function visualizeParallelSign(e, r) {
      return this._visualizeSnappingIndicator(new S({
        paths: [[e.lineStart, e.lineEnd]],
        spatialReference: r.coordinateHelper.spatialReference
      }), I);
    }
  }, {
    key: "visualizeRightAngleQuad",
    value: function visualizeRightAngleQuad(e, r) {
      return this._visualizeSnappingIndicator(new S({
        paths: [[e.previousVertex, e.centerVertex, e.nextVertex]],
        spatialReference: r.coordinateHelper.spatialReference
      }), C(e));
    }
  }, {
    key: "_visualizeSnappingIndicator",
    value: function _visualizeSnappingIndicator(i, t) {
      var _this2 = this;

      var n = new e({
        geometry: i,
        symbol: t
      });
      return this.graphicsLayer.add(n), r(function () {
        _this2.graphicsLayer.remove(n);
      });
    }
  }]);

  return h;
}(p);

var d = l.main.toArray(),
    g = [].concat(_toConsumableArray(l.main.toRgb()), [100]),
    u = new m({
  outline: new c({
    width: 1.5,
    color: d
  }),
  size: 15,
  color: [0, 0, 0, 0]
}),
    M = new m({
  outline: {
    width: .5,
    color: [0, 0, 0, 1]
  },
  size: 10,
  color: d
}),
    f = new y({
  data: {
    type: "CIMSymbolReference",
    symbol: {
      type: "CIMLineSymbol",
      symbolLayers: [{
        type: "CIMSolidStroke",
        enable: !0,
        capStyle: "Butt",
        joinStyle: "Round",
        miterLimit: 10,
        width: i(s.lineHintWidthTarget),
        color: d
      }]
    }
  }
}),
    I = new y({
  data: {
    type: "CIMSymbolReference",
    symbol: {
      type: "CIMLineSymbol",
      symbolLayers: [{
        type: "CIMVectorMarker",
        enable: !0,
        anchorPoint: {
          x: 0,
          y: -1,
          z: 0
        },
        anchorPointUnits: "Relative",
        size: 5,
        markerPlacement: {
          type: "CIMMarkerPlacementOnLine",
          placePerPart: !0,
          angleToLine: !0,
          relativeTo: "LineMiddle"
        },
        frame: {
          xmin: -5,
          ymin: -1.5,
          xmax: 5,
          ymax: 1.5
        },
        markerGraphics: [{
          type: "CIMMarkerGraphic",
          geometry: {
            rings: [[[7, 0], [-7, 0], [-7, 1.5], [7, 1.5]]]
          },
          symbol: {
            type: "CIMPolygonSymbol",
            symbolLayers: [{
              type: "CIMSolidFill",
              enable: !0,
              color: d
            }]
          }
        }],
        scaleSymbolsProportionally: !0,
        respectFrame: !0
      }, {
        type: "CIMVectorMarker",
        enable: !0,
        anchorPoint: {
          x: 0,
          y: 1,
          z: 0
        },
        anchorPointUnits: "Relative",
        size: 5,
        markerPlacement: {
          type: "CIMMarkerPlacementOnLine",
          placePerPart: !0,
          angleToLine: !0,
          relativeTo: "LineMiddle"
        },
        frame: {
          xmin: -5,
          ymin: -1.5,
          xmax: 5,
          ymax: 1.5
        },
        markerGraphics: [{
          type: "CIMMarkerGraphic",
          geometry: {
            rings: [[[7, 0], [-7, 0], [-7, -1.5], [7, -1.5]]]
          },
          symbol: {
            type: "CIMPolygonSymbol",
            symbolLayers: [{
              type: "CIMSolidFill",
              enable: !0,
              color: d
            }]
          }
        }],
        scaleSymbolsProportionally: !0,
        respectFrame: !0
      }]
    }
  }
}),
    P = function P(e) {
  return new y({
    data: {
      type: "CIMSymbolReference",
      symbol: {
        type: "CIMLineSymbol",
        symbolLayers: [{
          type: "CIMVectorMarker",
          enable: !0,
          anchorPoint: {
            x: .5,
            y: .5,
            z: 0
          },
          anchorPointUnits: "Relative",
          size: i(s.rightAngleHintSize),
          rotation: e,
          markerPlacement: {
            type: "CIMMarkerPlacementOnVertices",
            placePerPart: !0,
            angleToLine: !0,
            placeOnEndPoints: !1
          },
          frame: {
            xmin: -5,
            ymin: -5,
            xmax: 5,
            ymax: 5
          },
          markerGraphics: [{
            type: "CIMMarkerGraphic",
            geometry: {
              paths: [[[5, -5], [-5, -5], [-5, 5], [5, 5], [5, -5]]]
            },
            symbol: {
              type: "CIMLineSymbol",
              symbolLayers: [{
                type: "CIMSolidStroke",
                enable: !0,
                capStyle: "Butt",
                joinStyle: "Round",
                miterLimit: 10,
                width: i(s.rightAngleHintOutlineSize),
                color: d
              }, {
                type: "CIMSolidFill",
                enable: !0,
                color: g
              }]
            }
          }],
          scaleSymbolsProportionally: !0,
          respectFrame: !0
        }]
      }
    }
  });
},
    x = P(45),
    v = P(225),
    C = function () {
  var e = o(),
      r = o(),
      i = a();
  return function (o) {
    return t(e, o.centerVertex, o.previousVertex), t(r, o.nextVertex, o.previousVertex), n(i, e, r), i[2] < 0 ? x : v;
  };
}();

export { h as SnappingVisualizer2D };